import { useCallback, useEffect, useRef, useState } from 'react';

import type { UseCohortPickerSelectionArgs, UseCohortPickerSelectionResult } from '../types';

// Which cohort is currently highlighted in the picker, seeded once from the
// already-attached cohort. Isolated from list/search and confirm behavior so
// the seeding + pick logic can be tested independently.
export const useCohortPickerSelection = ({
  currentCohortId,
  allOptions,
}: UseCohortPickerSelectionArgs): UseCohortPickerSelectionResult => {
  // One-shot seed of the currently-attached cohort. `seededRef` guards against
  // later list refetches clobbering the user's subsequent picks.
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const seededRef = useRef(false);
  useEffect(() => {
    if (seededRef.current) return;
    if (!currentCohortId) return;
    if (!allOptions.some((o) => o.cohortProfileId === currentCohortId)) return;
    seededRef.current = true;
    setSelectedId(currentCohortId);
  }, [currentCohortId, allOptions]);

  const onSelect = useCallback((cohortProfileId: string) => setSelectedId(cohortProfileId), []);

  return { selectedId, onSelect };
};
